import React, { useEffect } from 'react';
import { t } from 'ttag';
import { CyberSecurityData } from '../..';
import sfx from '../../../../../services/sounds';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import Phisherman from '../../characters/Phisherman';
import Turtle from '../../characters/Turtle';

const TurtleOutro: React.FC<ISlide<CyberSecurityData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    useEffect(() => {
        data.playMusic(sfx.themeCybersecurity);
    }, []);

    const dialogue: DialogueData[] = [
        {
            character: Phisherman,
            textSpriteName: 'end-phisherman-1',
            text: t`I give up! You know too much about my phishing techniques, I'm going to have to find easier targets. You win this time!`,
            buttonText: t`Next`,
        },
        {
            character: Turtle,
            text: t`Incredible. You did brilliantly and you saved everyone from that nasty Phisherman's cyber attack! Well done!`,
            textSpriteName: 'endturtle-3-1',
            buttonText: t`Thank you!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default TurtleOutro;
